import bootLayout from 'tradera/legacy/static/app/boot/boot-layout';
import onReady from 'utils/on-ready';

export default (initData) => {
    onReady(() => {
        bootLayout(initData);
    });
};
